import React from 'react';
import './StaffAugWhyChoose.css';

const StaffAugWhyChoose = () => {
  return (
    <section className="staff-aug-why-choose-section">
      <div className="container">
        <div className="staff-aug-why-choose-grid">
          <div className="why-choose-text">
            <h2 className="why-choose-main-title">Why Choose Neuroverse AI ?</h2>
            <p>
              As one of the top SAP consulting firms in the USA, we pride ourselves on delivering solutions that drive tangible business outcomes. Our consultants bring decades of experience, innovative methodologies, and an in-depth understanding of SAP systems to ensure your business stays ahead in a competitive market.
            </p>
            <h3 className="why-choose-subtitle">Unlock the Power of Flexible Workforce Solutions</h3>
            <p>
              Our staff augmentation services in UK are designed to provide businesses with unparalleled flexibility and access to top-tier talent. Whether you’re looking to expand your team for a short-term project or need specialists for critical roles, we’ve got you covered.
            </p>
          </div>
          <div className="why-choose-features">
            <div className="feature-box">
              <h4>Expert Talent Pool</h4>
              <p>Gain access to highly experienced professionals across diverse industries.</p>
            </div>
            <div className="feature-box">
              <h4>Tailored Approach</h4>
              <p>We understand your requirements and customize our solutions accordingly.</p>
            </div>
            <div className="feature-box">
              <h4>Efficient Hiring</h4>
              <p>Save time and resources by letting us handle the hiring process.</p>
            </div>
            <div className="feature-box">
              <h4>Dynamic Scalability</h4>
              <p>Quickly adjust your workforce based on project demands.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StaffAugWhyChoose;
